import { render, staticRenderFns } from "./attribute-rule-configuration.vue?vue&type=template&id=b16c76f4&scoped=true&"
import script from "./attribute-rule-configuration.vue?vue&type=script&lang=ts&"
export * from "./attribute-rule-configuration.vue?vue&type=script&lang=ts&"
import style0 from "./attribute-rule-configuration.vue?vue&type=style&index=0&id=b16c76f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16c76f4",
  null
  
)

export default component.exports